var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value.firstAid)?_c('div',[_c('v-text-field',{attrs:{"label":_vm.$t('medkitlogs.nameFirstResponder'),"data-cy":"nameFirstAid","rules":_vm.requieredRule},model:{value:(_vm.value.nameFirstAid),callback:function ($$v) {_vm.$set(_vm.value, "nameFirstAid", $$v)},expression:"value.nameFirstAid"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }